/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { v1 as uuidv1 } from 'uuid';
import { api } from '@seaoil/component-lib';

import AsyncAutoComplete from './AsyncAutoComplete';

const { mySEAOIL } = api;

function ExpenseSubCategory1Field({
  // attributes
  placeholder,
  disabled,

  // object attributes
  config: {
    company_code,
    category,
  },

  // methods
  onInputSelect,
}) {
  const [subCategories, setSubCategories] = useState([]);
  const [loading, isLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [key, setKey] = useState(uuidv1());
  const retryLimit = 5;
  let retryCount = 0;

  const loadSubCategories = async () => {
    isLoading(() => true);
    try {
      const subCats = await mySEAOIL.datawarehouse.getExpenseAcctEntry({
        attribute: 'subcategory_1',
        parameters: { company_code, category },
      }).send();
      setSubCategories(subCats);
    } catch (e) {
      if (retryCount > retryLimit) {
        notification.error({ message: 'Unable to load subcategory 1 after multiple retries. Kindly contact supportdesk@seaoil.com.ph' });
      } else {
        notification.error({ message: 'Unable to load subcategory 1. Retrying after 2 seconds...' });
        setTimeout(loadSubCategories, 2000);
        retryCount += 1;
      }
    } finally {
      isLoading(() => false);
    }
  };

  useEffect(() => {
    setKey(uuidv1());
    setOptions([]);
    if (company_code && category) {
      loadSubCategories();
    }
  }, [company_code, category]);

  useEffect(() => {
    if (!Array.isArray(subCategories)) {
      return;
    }

    setOptions(subCategories.map(({
      subcategory_1,
    }) => ({
      value: subcategory_1,
      label: subcategory_1,
    })));
  }, [subCategories]);

  return (
    <AsyncAutoComplete
      key={key}
      placeholder={placeholder}
      loading={loading}
      disabled={disabled}
      options={options}
      onInputSelect={(subcat1) => {
        if (subCategories) {
          onInputSelect(subCategories.find(({ subcategory_1 }) => subcategory_1 === subcat1));
        }
      }}
    />
  );
}

export default ExpenseSubCategory1Field;
